import cn from 'classnames';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { StyledUl } from './pagination.styles';
import { usePagination } from '../../hooks/usePagination';

interface IPaginationProps {
    onPageChange: (page: number) => void;
    totalCount: number,
    siblingCount?: number,
    currentPage: number,
    pageSize: number,
    className?: string;
    // When set, every page item is a real <a href> so crawlers can follow it.
    getHref?: (page: number) => string;
}

export const Pagination = ({
    onPageChange,
    totalCount = 1,
    siblingCount = 0,
    currentPage = 1,
    pageSize = 1,
    className = '',
    getHref
}: IPaginationProps) => {

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // if (currentPage === 0 || (paginationRange?.length || 0) < 2) {
    //     return null;
    // }

    function onNext() {
        onPageChange(currentPage + 1);
    }

    function onPrevious() {
        onPageChange(currentPage - 1);
    }

    const lastPage = (paginationRange || [])[(paginationRange?.length || 0) - 1] || 1;

    function item(page: number, content: ReactNode, label?: string) {
        if (!getHref) {
            return content;
        }
        return (
            <Link href={getHref(page)} className="pagination-link" aria-label={label}>
                {content}
            </Link>
        );
    }

    return (
        <StyledUl
            className={cn('pagination-container', { [className]: className })}
        >
            <li
                className={cn('pagination-item', {
                    disabled: currentPage === 1
                })}
                onClick={getHref ? undefined : onPrevious}
            >
                {currentPage === 1 ? <div className="arrow left" /> : item(currentPage - 1, <div className="arrow left" />, "Previous page")}
            </li>
            {(paginationRange || []).map(pageNumber => {
                if (pageNumber === '...') {
                    return <li key={'...'} className="pagination-item dots">&#8230;</li>;
                }

                return (
                    <li
                        key={pageNumber}
                        className={cn('pagination-item', {
                            selected: pageNumber === currentPage
                        })}
                        onClick={getHref ? undefined : () => onPageChange(Number(pageNumber))}
                    >
                        {item(Number(pageNumber), pageNumber)}
                    </li>
                );
            })}
            <li
                className={cn('pagination-item', {
                    disabled: currentPage === lastPage
                })}
                onClick={getHref ? undefined : onNext}
            >
                {currentPage === lastPage ? <div className="arrow right" /> : item(currentPage + 1, <div className="arrow right" />, "Next page")}
            </li>
        </StyledUl>
    );
};

